import { Flex, SmallTile } from "lqx-react";
import * as React from "react";
import { NotSentInvoices } from "./not-sent";
import { OverdueInvoices } from "./overdue";
import { DisputedInvoices } from "./disputed";
import { UpcomingInvoices } from "./upcoming";
import { BrokenPromiseInvoices } from "./broken-promise";
import { SoaNotSent } from "./soa-not-sent";
import { LinkedAttr } from "@type-r/models/lib/model/linked-attrs";
import { InvoiceLandingSummary } from "../../api/invoices";
import { ChipWithLoading } from "../../common";

export const TodoTiles = ({ $category, model }: { $category: LinkedAttr<string>, model: InvoiceLandingSummary }) => {

    return (
        <>
            <SmallTile
                color="red"
                $selected={$category.equals('overdue')}
                right={<ChipWithLoading model={model.overDue} color={'red'} />}
                footer="Invoices past due date"
            >
                Overdue invoices
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('not-sent')}
                right={<ChipWithLoading model={model.notSent} />}
                footer="Invoices that need to be sent to the customer"
            >
                Invoices not sent
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('soa')}
                right={<ChipWithLoading model={model.itemsNotSent} />}
                footer="SOAs that needs to be sent to the customer"
            >
                Statement of Accounts not sent
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('disputed')}
                right={<ChipWithLoading model={model.disputedInvoices} />}
                footer="Invoices disputed by customers"
            >
                Disputed invoices
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('broken-promise')}
                right={<ChipWithLoading model={model.brokenPromiseInvoices} />}
                footer="Invoices where promise to pay date is overdue"
            >
                Invoices with broken promise
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('upcoming')}
                right={<ChipWithLoading model={model.upcommingInvoices} />}
                footer="Invoices due in 2 weeks without promise to pay date"
            >
                Upcoming invoices
            </SmallTile>
        </>
    )
}

export const TodoDetails = ({ category, state }: { category: string, state: InvoiceLandingSummary }) =>
    category === "soa" ? <SoaNotSent state={state.itemsNotSent}/>
        : category === 'not-sent' ? <NotSentInvoices state={state.notSent}/>
            : category === 'overdue' ? <OverdueInvoices state={state.overDue}/>
                : category === 'disputed' ? <DisputedInvoices state={state.disputedInvoices}/>
                    : category === 'upcoming' ? <UpcomingInvoices state={state.upcommingInvoices} />
                        : category === 'broken-promise' ? <BrokenPromiseInvoices state={state.brokenPromiseInvoices}/>
                            : <Flex center> <h2>Select the category on the left</h2> </Flex>

